import React from 'react';
import '../../assets/css/event2503.css';
import '../../assets/css/event2507.css';

import { TopButton } from "../../components/TopButton"
import { Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';



export default function Event2507() {

    useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `혹서기 캠페인 | 어르신본죽왔어요`;
    },[]);

    // gsap.registerPlugin(useGSAP, ScrollTrigger);
    const container = useRef();

    useGSAP(() => {
    let tl01 = gsap.timeline({
        default:{duration: 0.1},
    }); // 인트로

    let tl02 = gsap.timeline({
      default:{duration: 0.3},
    }); // 인트로

    tl01.from('.motiona1', { opacity: 0, y: 100, })
        .from('.motiona2', { opacity: 0, y: 100, })
        .from('.motiona3', { opacity: 0, y: 100, })
        .from('.motiona4', { opacity: 0, y: 100, })

    gsap.to('.motiona6', { scale: 0.95, repeat: -1, yoyo: true, duration: 0.5, })

    tl02.fromTo('.hoho01', { scale: 0 }, { opacity: 0,  scale: 1, y: -50, x:-10, duration: 1, repeat: -1 })
        .fromTo('.hoho02', { scale: 0 }, { opacity: 0, scale: 1, y: -50, x:10, duration: 1.5, repeat: -1, })
        .fromTo('.hoho03', { scale: 0 }, { opacity: 0, scale: 1, y: -50, x:10, duration: 1.3, repeat: -1, })

    }, { scope: container });
    
    

    return (
        <article id='evnet-body' ref={container}>
            
            <TopButton />
    
            <section id='july-top' className=''>
                <div id='july-bg01' className='july-inner section'>
                <div className='motiona1 mx350'><img src={process.env.PUBLIC_URL + 'upload/2507/july_title_01.png'} alt="" /></div>
                  <div className='motiona2 mx350'><img src={process.env.PUBLIC_URL + 'upload/2507/july_title_02.png'} alt="" /></div>
                  <div className='motiona3 mx350 hohodot'>
                    <img src={process.env.PUBLIC_URL + 'upload/2507/july_title_03.png'} alt="" />
                    <div className='hoho01'><img src={process.env.PUBLIC_URL + 'upload/2507/hoho.png'} alt="" /></div>
                    <div className='hoho02'><img src={process.env.PUBLIC_URL + 'upload/2507/hoho.png'} alt="" /></div>
                    <div className='hoho03'><img src={process.env.PUBLIC_URL + 'upload/2507/hoho.png'} alt="" /></div>
                  </div>
                  <div className='motiona4 mx350'><img src={process.env.PUBLIC_URL + 'upload/2507/july_title_04.png'} alt="" /></div>
                  
                    {/* <div className='motiona4 ptext'>홀로 계신 어르신들을 위해 매주 본죽을 나누며
                    따뜻한 마음의 안부를 전하고 있습니다.</div> */}
                </div>
            </section>
    
            <section id='july-about' className=''>
                <div id='july-bg02' className='july-inner'>
                  <div className='dot'><img src={process.env.PUBLIC_URL + 'upload/2507/july_event_02.jpg'} alt="" />
                  
                    <div className='btn-coupon'>
                      <Link to="http://pf.kakao.com/_rdmwd" target='_blank' rel="noopener noreferrer">
                        <img className='motiona6' src={process.env.PUBLIC_URL + 'upload/2507/btn_coupon.png'} alt="" />
                      </Link>
                    </div>
                                  
                    <div className='btn-donation'>
                      <Link to="https://happybean.naver.com/donation/rdonaboxes/H200000002981/story" target='_blank' rel="noopener noreferrer">
                        <img className='motiona6' src={process.env.PUBLIC_URL + 'upload/2507/btn_donation.png'} alt="" />
                      </Link>
                    </div>

                  </div>
                </div>
            </section>
    
            <section id='july-join' className=''>
                <div id='july-bg02' className='july-inner'>
                  <div className='dot'><img src={process.env.PUBLIC_URL + 'upload/2507/july_event_03.jpg'} alt="" />
                  
                    <div className='btn-join'>
                      <Link to="https://youtu.be/PJRTWaxf_f4?si=tisWzdXp9gFrN6na" target='_blank' rel="noopener noreferrer">
                        <img className='motiona6' src={process.env.PUBLIC_URL + 'upload/2507/btn_join.png'} alt="" />
                      </Link>
                    </div>

                  </div>
                </div>
            </section>
    

            <section id='july-footer' className=''>
                <div id='july-bg02' className='july-inner'>
                  <div className='dot'>
                    <img src={process.env.PUBLIC_URL + 'upload/2507/july_event_04.jpg'} alt="" />
                  
                  </div>
                </div>
            </section>
    

       </article>

    )
    
}